var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,1.667A8.333,8.333,0,1,0,18.333,10,8.343,8.343,0,0,0,10,1.667Zm3.923,12.256a.833.833,0,0,1-1.178,0L10,11.178,7.256,13.923a.833.833,0,0,1-1.178-1.178L8.822,10,6.077,7.256A.833.833,0,0,1,7.256,6.077L10,8.822l2.744-2.744a.833.833,0,0,1,1.178,1.178L11.178,10l2.744,2.744A.832.832,0,0,1,13.923,13.923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleWhite);
export default __webpack_public_path__ + "static/media/close-circle-white.978ee64efcd6e7fe39654ee658ccb8b2.svg";
export { ForwardRef as ReactComponent };